export default __webpack_public_path__ + "static/media/addressbrown.b89fdf38.svg";